import React, { useState } from 'react';
import { DillButton, DillModal } from '../../../general/Dill';
import { openDillToast } from '../../../../utils/helpers';
import { AppInputField } from '../../../general/AppInputField/AppInputField';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import {
  resendCreditApplicationLink,
  resendRequestCreditAppSignature,
  requestSignatureDetailsUpdate,
} from '../../../../redux/services/creditApplicationsService';
import { InvitedSignatures } from '@dill/dill-shared/dist/src';

const CreditAppCommentModal = ({
  open,
  handleClose,
  type,
  title,
  creditApplicationId,
  sigDetails,
  onSuccess,
}: {
  open: boolean;
  handleClose: () => void;
  type: string;
  title: string;
  creditApplicationId: string;
  sigDetails?: InvitedSignatures;
  onSuccess?: () => void;
}) => {
  const dispatch = useAppDispatch();
  const { user, currentSupplier } = useAppSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [text, setText] = useState('');

  const handleCloseModal = () => {
    setLoading(false);
    setText('');
    handleClose();
  };

  const handleSubmit = async () => {
    setLoading(true);
    let details = {};
    let results = null;
    if (text.trim() !== '') {
      details = { comment: text };
    }
    if (type === 'resend-draft') {
      results = await dispatch(
        resendCreditApplicationLink({
          creditApplicationId: creditApplicationId,
          supplierId: currentSupplier?.id || '',
          ...details,
        })
      );
    }
    if (type === 'resend-signature' && sigDetails) {
      results = await dispatch(
        resendRequestCreditAppSignature({
          creditApplicationId: creditApplicationId,
          invitedSignature: sigDetails,
          supplierId: currentSupplier?.id || '',
          ...details,
        })
      );
    }
    if (type === 'request-signature-update' && sigDetails) {
      results = await dispatch(
        requestSignatureDetailsUpdate({
          creditApplicationId: creditApplicationId,
          invitedSignature: sigDetails,
          supplierId: currentSupplier?.id || '',
          ...details,
        })
      );
    }
    let errorMessage = '';
    let successMessage = '';
    if (type === 'resend-draft') {
      successMessage = 'Successfully resent application link';
      errorMessage = 'Failed to resend application link';
    }
    if (type === 'resend-signature') {
      successMessage = 'Successfully resent signature request';
      errorMessage = 'Failed to resend request for signature';
    }
    if (type === 'request-signature-update') {
      successMessage = 'Successfully requested signature details update';
      errorMessage = 'Failed to request for update signature details';
    }
    if (results && results.type.includes('fulfilled')) {
      openDillToast({
        type: 'SUCCESS',
        message: `${successMessage}`,
      });
      onSuccess?.();
    } else {
      openDillToast({
        type: 'ERROR',
        message: `${errorMessage}`,
      });
    }
    setLoading(false);
    handleCloseModal();
  };

  return (
    <DillModal
      open={open}
      onClose={handleCloseModal}
      title={title}
      footer={
        <div className="flex justify-end w-full gap-2">
          <DillButton label="Close" variant="secondary" onClick={handleCloseModal} />
          <DillButton
            label="Submit"
            onClick={handleSubmit}
            isLoading={loading}
            isDisabled={loading}
          />
        </div>
      }>
      <AppInputField
        label="Comment"
        value={text}
        inputType="textarea"
        onTextChange={(val) => {
          setText(val);
        }}
      />
    </DillModal>
  );
};

export default CreditAppCommentModal;
